module.exports = __webpack_public_path__ + "assets/img/29_240_big.f2da41f8.jpg";